module.exports = __webpack_public_path__ + "img/banner-escritorio-mobile.6e17d4b9.png";